export default __webpack_public_path__ + "media/images/document-dossier-g3805-vert-papier-icone-5435-96-db0428f2c871e6cbb12fe8bf68d894a6.png";